export default "__VITE_ASSET__F_tqoxL0__"